var map = {
	"./cardFrame_S_1.png": "7e68",
	"./cardFrame_S_2.png": "88b5",
	"./cardFrame_S_3.png": "dea1",
	"./cardFrame_S_4.png": "af9f",
	"./cardFrame_S_bd.png": "afce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4894";